/**
 * Library for generically accessing key data.
 */
export async function loadKeyData(client, mine, key) {
    return (await client.post('api/key_data/pull', { mine, key })).data.value;
}
export async function saveKeyData(client, mine, key, data) {
    await client.post('api/key_data/save', { mine, key, data });
}
